import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getProductIds } from '@features/crm/utils/helpers';
import BottomPopup from '@features/crm/sales-funel/components/BottomPopup';
import EODModal from '@features/crm/sales-funel/components/EODModal';

import { storeCRMProducts } from '@store/actions/crm/CRMCommonAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { closeCrmProductStyles, restoreCrmProductStyles } from '@services/crmService';

import { getQueryParamsFromArray } from '@utils/helper';

const BottomActions = ({ allProducts, fetchSalesFunnelTableData }) => {
	const dispatch = useDispatch();

	const [showEDDModal, setShowEDDModal] = useState(false);
	const selectedCRMProducts = useSelector((state) => state.crmCommonStore.selectedCRMProducts);

	const selectProducts = async (isSelectAll) => {
		if (isSelectAll) {
			await dispatch(storeCRMProducts(allProducts));
		} else {
			await dispatch(storeCRMProducts([]));
		}
	};

	const reStoreStyles = async () => {
		let params = '';
		if (selectedCRMProducts) {
			params += `?idList=${getQueryParamsFromArray(getProductIds(selectedCRMProducts))}`;
		}
		try {
			dispatch(openLoader());
			await restoreCrmProductStyles(params);
			await fetchSalesFunnelTableData(0);
			dispatch(closeLoader());
			await dispatch(storeCRMProducts([]));
		} catch {
			dispatch(closeLoader());
		}
	};

	const closeStyles = async () => {
		let params = '';
		if (selectedCRMProducts) {
			params += `?idList=${getQueryParamsFromArray(getProductIds(selectedCRMProducts))}`;
		}
		try {
			dispatch(openLoader());
			await closeCrmProductStyles(params);
			await fetchSalesFunnelTableData(0);
			dispatch(closeLoader());
			await dispatch(storeCRMProducts([]));
		} catch {
			dispatch(closeLoader());
		}
	};

	const onClearSelectedProducts = async () => {
		await dispatch(storeCRMProducts([]));
	};

	const isUnselectedAll = (allProducts) => {
		return allProducts.length === selectedCRMProducts.length;
	};

	const onActionClick = (type) => {
		switch (type) {
			case 'SELECT_ALL':
				selectProducts(true);
				break;
			case 'UN_SELECT_ALL':
				selectProducts(false);
				break;
			case 'EOD':
				setShowEDDModal(true);
				break;
			case 'RESTORE_STYLE':
				reStoreStyles();
				break;
			case 'CLOSE_STORE':
				closeStyles();
				break;

			case 'CLEAR':
				onClearSelectedProducts();
				break;

			default:
				break;
		}
	};
	return (
		<>
			<BottomPopup
				onActionClick={(type) => onActionClick(type)}
				allProducts={allProducts}
				showUnSelectAll={isUnselectedAll(allProducts)}
			/>
			{showEDDModal && (
				<EODModal
					showEDDModal={showEDDModal}
					setShowEDDModal={setShowEDDModal}
					onClearSelectedProducts={onClearSelectedProducts}
					fetchSalesFunnelTableData={fetchSalesFunnelTableData}
				/>
			)}
		</>
	);
};
export default BottomActions;
